(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  qsa("[data-aa-announcement]").forEach((bar) => {
    const items = qsa("span", bar);
    if (items.length < 2) return;
    let index = 0;
    items[0].classList.add("is-active");
    window.setInterval(() => {
      items[index].classList.remove("is-active");
      index = (index + 1) % items.length;
      items[index].classList.add("is-active");
    }, 5000);
  });

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-aa-toggle]");
    if (toggle) {
      const target = qs(toggle.getAttribute("data-aa-toggle"));
      if (target) {
        const isOpen = target.classList.toggle("is-open");
        target.setAttribute("aria-hidden", isOpen ? "false" : "true");
      }
    }
    const close = event.target.closest("[data-aa-close]");
    if (close) {
      const target = close.getAttribute("data-aa-close");
      const panel = target ? qs(target) : close.closest(".is-open");
      panel?.classList.remove("is-open");
      panel?.setAttribute("aria-hidden", "true");
    }
  });

  qsa(".aa-accordion").forEach((wrap) => {
    qsa("details", wrap).forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (!detail.open) return;
        qsa("details", wrap).forEach((other) => {
          if (other !== detail) other.removeAttribute("open");
        });
      });
    });
  });

  qsa(".aa-gallery-tile").forEach((tile) => {
    tile.addEventListener("pointermove", (event) => {
      const rect = tile.getBoundingClientRect();
      tile.style.setProperty("--aa-x", `${((event.clientX - rect.left) / rect.width) * 100}%`);
      tile.style.setProperty("--aa-y", `${((event.clientY - rect.top) / rect.height) * 100}%`);
    });
  });

  const revealObserver = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12 })
    : null;
  qsa(".aa-reveal").forEach((el) => revealObserver ? revealObserver.observe(el) : el.classList.add("is-visible"));

  const mainCta = qs("[data-aa-main-cta]");
  const sticky = qs("[data-aa-sticky-cta]");
  if (mainCta && sticky && "IntersectionObserver" in window) {
    const ctaObserver = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle("is-visible", !entry.isIntersecting);
    }, { threshold: 0 });
    ctaObserver.observe(mainCta);
  }

  qsa(".aa-product-form").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      const button = form.querySelector("[type='submit']");
      const original = button?.textContent;
      try {
        const body = new FormData(form);
        const response = await fetch("/cart/add.js", { method: "POST", body, headers: { "Accept": "application/json" } });
        if (!response.ok) throw new Error("cart add failed");
        if (button) button.textContent = "hinzugefügt";
        document.dispatchEvent(new CustomEvent("aa:cart:refresh"));
        const cartPanel = qs("#aa-cart-panel");
        cartPanel?.classList.add("is-open");
        cartPanel?.setAttribute("aria-hidden", "false");
      } catch (error) {
        form.submit();
      } finally {
        if (button && original) window.setTimeout(() => { button.textContent = original; }, 1600);
      }
    });
  });

  const FREE_SHIPPING_THRESHOLD_CENTS = 15000;

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll("\"", "&quot;")
      .replaceAll("'", "&#039;");
  }

  function cartRecommendationsHtml(panel) {
    return qs("[data-aa-cart-recommendations-template]", panel)?.innerHTML || "";
  }

  function imageUrlWithWidth(url, width) {
    if (!url) return "";
    return `${url}${url.includes("?") ? "&" : "?"}width=${width}`;
  }

  function shuffleCartRecommendations(root = document, cartHandles = []) {
    const handleSet = new Set(cartHandles.filter(Boolean));
    qsa("[data-aa-cart-rec-list]", root).forEach((list) => {
      const items = qsa("[data-aa-cart-rec-item]", list).filter((item) => !handleSet.has(item.dataset.aaCartRecHandle));
      if (!items.length) return;

      qsa("[data-aa-cart-rec-item]", list).forEach((item) => {
        item.hidden = true;
      });

      items
        .map((item) => ({ item, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .forEach(({ item }, index) => {
          item.hidden = index >= 4;
          list.appendChild(item);
        });
    });
  }

  function renderCartBody(cart, panel) {
    const target = qs("[data-aa-cart-body]", panel);
    if (!target) return;

    if (!cart.items?.length) {
      target.innerHTML = `
        <p class="aa-copy">Dein Warenkorb ist noch leer. Schau dich im Archive um.</p>
        <a class="aa-btn aa-btn--primary aa-cart-empty-link" href="/collections/available">Pieces ansehen</a>
      `;
      return;
    }

    const remaining = Math.max(FREE_SHIPPING_THRESHOLD_CENTS - Number(cart.total_price || 0), 0);
    const progress = Math.min(Math.round((Number(cart.total_price || 0) / FREE_SHIPPING_THRESHOLD_CENTS) * 100), 100);
    const shippingText = remaining > 0
      ? `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand.`
      : "Kostenloser Versand erreicht.";

    const lines = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== "Default Title" ? `${escapeHtml(item.variant_title)} · ` : "";
      return `
        <div class="aa-cart-line">
          <a class="aa-cart-line__media" href="${escapeHtml(item.url)}">
            ${item.image ? `<img src="${escapeHtml(imageUrlWithWidth(item.image, 180))}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ""}
          </a>
          <div class="aa-cart-line__body">
            <a class="aa-cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            <div class="aa-meta">${variant}Menge: ${item.quantity}</div>
          </div>
          <span class="aa-cart-line__price">${formatMoney(item.final_line_price)}</span>
        </div>
      `;
    }).join("");

    target.innerHTML = `
      <div class="aa-cart-shipping" data-aa-cart-shipping>
        <div class="aa-cart-shipping__top"><span>${shippingText}</span></div>
        <div class="aa-cart-shipping__track" aria-hidden="true"><span style="width: ${progress}%;"></span></div>
      </div>
      <div class="aa-cart-lines">${lines}</div>
      <div class="aa-cart-actions">
        <a class="aa-btn aa-btn--primary" href="/checkout">Zur Kasse</a>
        <a class="aa-cart-secondary-link" href="/cart">Warenkorb ansehen</a>
      </div>
      ${cartRecommendationsHtml(panel)}
    `;

    shuffleCartRecommendations(panel, cart.items.map((item) => item.handle || item.product_handle));
  }

  async function refreshCart() {
    const panel = qs("#aa-cart-panel");
    if (!panel || !window.fetch) return;
    try {
      const cart = await fetch("/cart.js", { headers: { "Accept": "application/json" } }).then((r) => r.json());
      qsa("[data-aa-cart-count]").forEach((el) => { el.textContent = cart.item_count || 0; });
      renderCartBody(cart, panel);
    } catch (error) {}
  }
  document.addEventListener("aa:cart:refresh", refreshCart);
  qs("[data-aa-toggle='#aa-cart-panel']")?.addEventListener("click", refreshCart);
  shuffleCartRecommendations(document);

  const viewedKey = "aa_recently_viewed";
  const productHandle = document.body.dataset.aaProductHandle;
  if (productHandle) {
    const list = JSON.parse(localStorage.getItem(viewedKey) || "[]").filter((item) => item.handle !== productHandle);
    list.unshift({ handle: productHandle, title: document.body.dataset.aaProductTitle || productHandle, url: location.pathname });
    localStorage.setItem(viewedKey, JSON.stringify(list.slice(0, 8)));
  }
})();
